'use client';

import { type RefObject, type PropsWithChildren, type ReactNode } from 'react';
import { CarouselProvider } from '@packages/modules/src/Carousel/CarouselProvider';
import { CarouselWrapper } from '@packages/modules/src/Carousel/CarouselWrapper.client';
import { CarouselNav } from '@packages/modules/src/Carousel/CarouselNav.client';
import { CarouselList } from '@packages/modules/src/Carousel/CarouselList.client';
import { CarouselLoadingList, type CarouselLoadingListProps } from './CarouselLoadingList.client';

type RecoCarouselProps = PropsWithChildren<{
  title: string;
  loadingState?: boolean;
  backgroundColor?: string;
  ref?: RefObject<HTMLDivElement | null>;
  slot?: ReactNode;
}> &
  CarouselLoadingListProps;

export const RecoCarousel = ({
  children,
  title,
  loadingState = false,
  backgroundColor,
  ref,
  type = 'PRODUCT',
  slot,
}: RecoCarouselProps) => (
  <div ref={ref}>
    <div className="text-size-h4 lg:text-size-h3 my-2 px-1.5 lg:px-2">
      {loadingState ? (
        <div className="bg-color-grey h-4 w-[200px] animate-pulse" />
      ) : (
        <p>{title}</p>
      )}
    </div>
    <CarouselProvider>
      <CarouselWrapper style={{ backgroundColor }}>
        {loadingState ? (
          <CarouselLoadingList type={type} />
        ) : (
          <>
            <CarouselNav />
            <CarouselList>{children}</CarouselList>
            {slot}
          </>
        )}
      </CarouselWrapper>
    </CarouselProvider>
  </div>
);
